module.exports = __webpack_public_path__ + "static/media/startNow.8b0291bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/CXLanding/images/startNow.png
// module id = 1281
// module chunks = 0